import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SelecionarLotesRecebimento, SelecionarPedidosRecebimento, FiltroPrePedido, Kits, RequisicaoPedidosRecebimento } from 'src/app/@shared/models/recepcao-fisica.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})

export class RecepcaoFisicaService {

  constructor(private http: HttpClient) { }

  selecionarLotesRecebimento(obj: any): Observable<HttpResponse<SelecionarLotesRecebimento[]>> {
    return this.http
      .post<SelecionarLotesRecebimento[]>(`PrePedido/SelecionarLotesRecebimento/`,
        obj,
        { observe: 'response' }
      );
  }

  selecionarPedidosRecebimento(obj: RequisicaoPedidosRecebimento):
    Observable<HttpResponse<SelecionarPedidosRecebimento[]>> {
    return this.http
      .post<SelecionarPedidosRecebimento[]>(`PrePedido/SelecionarPedidosRecebimento/`,
        obj,
        { observe: 'response' });
  }

  selecionarPrePedidoModeloLote(loteId?: number): Observable<Kits[]> {
    return this.http
      .get<Kits[]>(`PrePedido/SelecionarPrePedidoModeloLote/${loteId}`, httpOptions);
  }

  selecionarPrePedidoModeloPedido(PedidoId?: number): Observable<Kits[]> {
    return this.http
      .get<Kits[]>(`PrePedido/SelecionarPrePedidoModeloPedido/${PedidoId}`, httpOptions);

  }

  recepcionarPrePedidoNRT(filter: FiltroPrePedido): Observable<FiltroPrePedido[]> {
    return this.http
      .put<FiltroPrePedido[]>(`PrePedido/RecepcionarPrePedidoNRT`, filter, httpOptions);
  }

  recepcionarPrePedidoArquivo(filter: FiltroPrePedido): Observable<FiltroPrePedido[]> {
    return this.http
      .put<FiltroPrePedido[]>(`PrePedido/RecepcionarPrePedidoArquivo`, filter, httpOptions);
  }

  selecionarModeloCodigoBarra(loteId?: number, StatusId?: number): Observable<any> {
    return this.http
      .get<any>(`PrePedido/SelecionarModeloCodigoBarra/${loteId}/${StatusId}`, httpOptions);
  }

  selecionarModeloCodigoBarraPedido(pedidoId?: number): Observable<any> {
    return this.http
      .get<any>(`PrePedido/selecionarModeloCodigoBarraPedido/${pedidoId}`, httpOptions);
  }

  selecionarCabecalhoLoteRecebimento(loteId?: number): Observable<any> {
    return this.http
      .get<any>(`PrePedido/SelecionarCabecalhoLoteRecebimento/${loteId}`, httpOptions);
  }

  selecionarCabecalhoPedidoRecebimento(pedidoId?: number): Observable<any> {
    return this.http
      .get<any>(`PrePedido/SelecionarCabecalhoPedidoRecebimento/${pedidoId}`, httpOptions);
  }
}
